import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image";

import Address from "../address"
import * as style from './globe.module.scss'

const GlobeMenuItemFull = ({ office }) => {
  return (
    <li className={style.globeMenuItemFull}>
      <div className={style.columnImage}>
        <Link to={office.link}>
          {office.Header.headerImage && (
          <GatsbyImage
            image={office.Header.headerImage.localFile.childImageSharp.gatsbyImageData}
            alt={office.Header.headerImage.altText}
            title={office.Header.headerImage.title} />
          )}
        </Link>
      </div>
      <div className={style.columnCopy}>
        <Link to={office.link}>
          <h4>{office.title}</h4>
        </Link>
        <Address addresses={office.OfficeAddress.address} addressLabel='' phoneLabel='T' emailLabel='E' />
        <div className={style.linkWrap}>
          {office.OfficeData.jobLink && office.OfficeData.jobLink.url && (
            <a href={office.OfficeData.jobLink.url} className={style.jobLink} target="_blank" rel="noreferrer">Oferty pracy &rarr;</a>
          )}
          {office.OfficeData.jobLink && office.OfficeData.jobLink.email && (
            <a href={'mailto:' + office.OfficeData.jobLink.email} className={style.jobLink}>Oferty pracy &rarr;</a>
          )}
          <Link to={office.link} className={style.urlLink}>Dowiedz się więcej &rarr;</Link>
        </div>
      </div>
    </li>
  );
}

GlobeMenuItemFull.propTypes = {
  office: PropTypes.object.isRequired
}

export default GlobeMenuItemFull
